import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const LanguageContext = createContext(null);

const STRINGS = {
    ar: {
        dir: "rtl",
        saveTheDate: "احفظ الموعد",
        clickToOpen: "اضغط لفتح الدعوة",
        areGettingMarried: "نتشرف بدعوتكم لحضور حفل زفاف",
        at: "في تمام الساعة",
        scrollDown: "اسحب للأسفل",
        ourSpecialDay: "يومنا المميز",
        countingEveryMoment: "نعد اللحظات لنحتفل معكم",
        days: "يوم",
        hours: "ساعة",
        minutes: "دقيقة",
        seconds: "ثانية",
        joinUsAt: "تفضلوا بزيارتنا",
        tapToOpenMap: "اضغط على الخريطة للاتجاهات",
        clickMap: "اضغط للحصول على الاتجاهات",
        writeUsMessage: "اتركوا لنا رسالة",
        leaveHandwritten: "اكتبوا لنا رسالة",
        drawnMessage: "رسالة مرسومة",
        writtenMessage: "رسالة مكتوبة",
        writeMessageHere: "اكتب رسالتك هنا...",
        yourName: "اسمك",
        enterYourName: "من فضلك ادخل اسمك",
        clear: "مسح",
        undo: "تراجع",
        sendMessage: "إرسال الرسالة",
        messageSent: "تم إرسال رسالتك، شكراً لك!",
        willYouJoin: "هل ستشرفوننا؟",
        honored: "يسعدنا ويشرفنا حضوركم",
        attending: "سأحضر",
        notAttending: "لن أستطيع الحضور",
        numberOfGuests: "عدد المرافقين",
        guestNames: "أسماء المرافقين",
        guest: "مرافق",
        guests: "مرافقين",
        guestNumber: "المرافق",
        submit: "تأكيد المرافقين",
        addCompanions: "تحب تزود مرافقين؟",
        noCompanions: "لا يوجد مرافقين",
        rsvpSuccess: "شكراً لتأكيد الحضور!",
        companionsUpdated: "شكرا، الفرح هينور بيكو",
        noCompanionsThanks: "شكرا، الفرح هينور بيك",
        rsvpDeclined: "شكراً لإخباركم. سنفتقدكم!",
        sharePhotos: "شاركونا صوركم وفيديوهاتكم من الحفل",
        uploadPhotosText: "ارفعوا الصور والفيديوهات التي تلتقطونها لنحتفظ بهذه الذكريات معاً",
        uploadYourPhotos: "ارفع صورك وفيديوهاتك",
        uploading: "جاري الرفع...",
        uploadQueued: "في الانتظار",
        uploadSaving: "جاري الحفظ في Google Drive...",
        uploadDone: "تم الرفع",
        uploadFailed: "فشل الرفع",
        someUploadsFailed: "تعذر رفع بعض الملفات",
        photosUploaded: "تم رفع الملفات بنجاح",
        dearGuest: "الأعزاء",
        footer: "جميع الحقوق محفوظة © 2026",
        colors: "الألوان",
        size: "الحجم",
        thin: "رفيع",
        medium: "متوسط",
        thick: "عريض",
        bold: "سميك",
        current: "الحالي",
        weddingOf: "حفل زفاف",
        and: "و",
        adminPanel: "لوحة الإدارة",
        login: "تسجيل الدخول",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        logout: "تسجيل الخروج",
        guestsList: "قائمة المدعوين",
        addGuest: "إضافة مدعو",
        addMultiple: "إضافة عدة أشخاص",
        pasteNames: "الصق الأسماء (اسم في كل سطر)",
        copyLink: "نسخ الرابط",
        copied: "تم النسخ!",
        remove: "حذف",
        rsvps: "الردود",
        messagesTab: "الرسائل",
        photosTab: "الصور",
        statsTab: "الإحصائيات",
        adminLoginTitle: "لوحة الإدارة",
        adminSignIn: "تسجيل الدخول",
        adminSigningIn: "جارٍ تسجيل الدخول...",
        adminWelcome: "مرحباً",
        adminInvalidCredentials: "بيانات الدخول غير صحيحة",
        adminDashboardTitle: "إدارة الزفاف",
        adminWeddingFallback: "الزفاف",
        adminDateNotSet: "لم يُحدد التاريخ",
        adminAllWeddings: "كل الأفراح",
        adminWeddingsTitle: "الأفراح",
        adminWeddingsHint: "كل حفل له مدعووه ودعواته ولوحة الإدارة الخاصة به.",
        adminCreateWedding: "زفاف جديد",
        adminWeddingSlug: "المعرّف",
        adminSlugHint: "أحرف إنجليزية صغيرة وأرقام وشرطات، من 2 إلى 40.",
        adminDriveFolder: "معرّف مجلد Drive",
        adminCreateWeddingButton: "إنشاء الزفاف",
        adminWeddingCreated: "تم إنشاء الزفاف",
        adminWeddingAdminEmail: "بريد مدير الزفاف",
        adminWeddingAdminPassword: "كلمة مرور مدير الزفاف",
        adminWeddingAdminHint: "اختياري. أدخل البريد وكلمة المرور معاً لإنشاء حساب لهذا الزفاف فقط.",
        adminWeddingAdminBothRequired: "أدخل بريد مدير الزفاف وكلمة المرور معاً",
        adminWeddingAdminCreated: "تم إنشاء الزفاف وحساب المدير",
        adminNoWeddings: "لا توجد أفراح بعد.",
        adminOpenDashboard: "فتح اللوحة",
        adminCopyOpenLink: "نسخ رابط الدعوة",
        adminStatGuests: "المدعوون",
        adminStatOpened: "تم الفتح",
        adminStatAttending: "الحضور",
        adminStatMessages: "الرسائل",
        adminStatPhotos: "الصور",
        adminTabGuests: "المدعوون",
        adminTabRsvps: "الردود",
        adminTabMessages: "الرسائل",
        adminTabPhotos: "الصور",
        adminTabSettings: "الإعدادات",
        adminOpenInvitation: "رابط الدعوة المفتوحة",
        adminCopy: "نسخ",
        adminOpen: "فتح",
        adminWhatsapp: "واتساب",
        adminQr: "رمز QR",
        adminQrTitle: "رمز الدعوة",
        adminQrDownload: "تنزيل الرمز",
        adminQrAlt: "رمز الاستجابة السريعة للدعوة",
        adminGuestNamePlaceholder: "اسم المدعو...",
        adminCategoryPlaceholder: "الفئة...",
        adminAdd: "إضافة",
        adminBulkAdd: "إضافة جماعية",
        adminBulkCategoryPlaceholder: "فئة الإضافة الجماعية...",
        adminPasteNamesPlaceholder: "الصق الأسماء، اسم في كل سطر...",
        adminAddAll: "إضافة الكل",
        adminFilterPlaceholder: "ابحث بالاسم العربي أو الإنجليزي...",
        adminAllCategories: "كل الفئات",
        adminExportCsv: "تصدير CSV",
        adminColName: "الاسم",
        adminColCategory: "الفئة",
        adminColEnglishName: "الاسم بالإنجليزية",
        adminColLinkSent: "أُرسل الرابط؟",
        adminColLink: "الرابط",
        adminColClicks: "النقرات",
        adminColRsvp: "الرد",
        adminColActions: "إجراءات",
        adminEmptyGuests: "لا يوجد مدعوون بعد. أضف أول مدعو من الأعلى.",
        adminNoFilterMatch: "لا يوجد مدعوون يطابقون هذه التصفية.",
        adminOpenLink: "الدعوة المفتوحة",
        adminCategoryInputPlaceholder: "الفئة",
        adminEnglishNamePlaceholder: "اسم المدعو بالإنجليزية",
        adminSent: "أُرسل",
        adminNotSent: "لم يُرسل",
        adminClickOne: "نقرة",
        adminClickMany: "نقرات",
        adminNever: "أبداً",
        adminRsvpNo: "لا",
        adminPending: "بانتظار الرد",
        adminTitleCopyLink: "نسخ الرابط",
        adminTitleShare: "مشاركة",
        adminTitleDelete: "حذف",
        adminColGuest: "المدعو",
        adminColAttending: "الحضور",
        adminColCount: "العدد",
        adminColNames: "الأسماء",
        adminColTime: "الوقت",
        adminEmptyRsvps: "لا توجد ردود بعد.",
        adminYes: "نعم",
        adminEmptyMessages: "لا توجد رسائل بعد.",
        adminDrawnMessageAlt: "رسالة مرسومة",
        adminEmptyPhotos: "لا توجد وسائط بعد.",
        adminOpenInDrive: "فتح في Drive",
        adminVideo: "فيديو",
        adminUploadedAlt: "ملف مرفوع",
        adminDeletePhoto: "حذف الصورة",
        adminSettingsHeading: "تفاصيل الزفاف",
        adminSettingsHint: "تظهر هذه البيانات في كل روابط الدعوة.",
        adminTheme: "المظهر",
        adminSaving: "جارٍ الحفظ...",
        adminSaveSettings: "حفظ الإعدادات",
        adminGroomEn: "اسم العريس بالإنجليزية",
        adminBrideEn: "اسم العروس بالإنجليزية",
        adminGroomAr: "اسم العريس بالعربية",
        adminBrideAr: "اسم العروس بالعربية",
        adminStartDate: "تاريخ ووقت البداية",
        adminEndDate: "تاريخ ووقت النهاية",
        adminVenueEn: "اسم المكان بالإنجليزية",
        adminVenueAr: "اسم المكان بالعربية",
        adminHallEn: "اسم القاعة بالإنجليزية",
        adminHallAr: "اسم القاعة بالعربية",
        adminCityEn: "المدينة بالإنجليزية",
        adminCityAr: "المدينة بالعربية",
        adminAddressEn: "العنوان بالإنجليزية",
        adminAddressAr: "العنوان بالعربية",
        adminMapsUrl: "رابط خرائط جوجل",
        adminMapsEmbed: "رابط الخريطة المضمّنة",
        adminNoteEn: "ملاحظة بالإنجليزية",
        adminNoteAr: "ملاحظة بالعربية",
        adminGuestAdded: "تمت إضافة المدعو ونسخ الرابط",
        adminError: "خطأ",
        adminGuestsAdded: "تمت إضافة {count} من المدعوين",
        adminConfirmOpenRegistration: "سيؤدي هذا إلى حذف تسجيل الدعوة المفتوحة.",
        adminConfirmDeleteGuest: "حذف هذا المدعو وكل بياناته؟",
        adminConfirmDeletePhoto: "حذف هذه الصورة؟",
        adminLinkCopied: "تم نسخ الرابط",
        adminCopyPrompt: "انسخ هذا الرابط:",
        adminInvitationCopied: "تم نسخ رابط الدعوة",
        adminShareTitle: "دعوة زفاف",
        adminNoExport: "لا يوجد مدعوون مطابقون للتصدير",
        adminSettingsSaved: "تم حفظ إعدادات الزفاف",
        adminSettingsSaveFailed: "تعذر حفظ إعدادات الزفاف",
        adminCsvName: "الاسم",
        adminCsvEnglishName: "الاسم بالإنجليزية",
        adminCsvCategory: "الفئة",
        adminCsvInviteLink: "رابط الدعوة",
        langSwitch: "EN",
    },
    en: {
        dir: "ltr",
        saveTheDate: "Save the Date",
        clickToOpen: "Tap to open invitation",
        areGettingMarried: "We are honored to invite you to our wedding celebration",
        invitedToWedding: "You are invited to attend the wedding of",
        at: "at",
        scrollDown: "Scroll down",
        ourSpecialDay: "Our Special Day",
        countingEveryMoment: "Counting every moment to celebrate with you",
        days: "Days",
        hours: "Hours",
        minutes: "Minutes",
        seconds: "Seconds",
        joinUsAt: "Join Us At",
        tapToOpenMap: "Tap the map to open",
        clickMap: "Click map for directions",
        writeUsMessage: "Write Us a Message",
        leaveHandwritten: "Leave us a handwritten note or message",
        drawnMessage: "Drawn Message",
        writtenMessage: "Written Message",
        writeMessageHere: "Write your message here...",
        yourName: "Your Name",
        enterYourName: "Please enter your name",
        clear: "Clear",
        undo: "Undo",
        sendMessage: "Send Message",
        messageSent: "Thank you! Your message has been sent.",
        willYouJoin: "Will You Join Us?",
        honored: "We would be honored to celebrate with you",
        attending: "Attending",
        notAttending: "Not attending",
        numberOfGuests: "Number of companions",
        guestNames: "Companion names",
        guest: "Companion",
        guests: "Companions",
        guestNumber: "Companion",
        submit: "Confirm companions",
        addCompanions: "Would you like to add companions?",
        noCompanions: "No companions",
        rsvpSuccess: "Thank you for confirming!",
        companionsUpdated: "Companions updated",
        noCompanionsThanks: "Thank you, we are excited to celebrate with you",
        rsvpDeclined: "Thanks for letting us know. You'll be missed!",
        sharePhotos: "Share Your Photos And Videos From The Day",
        uploadPhotosText: "Upload the photos and videos you take during our celebration so we can cherish these memories together",
        uploadYourPhotos: "Upload Your Photos",
        uploading: "Uploading...",
        uploadQueued: "Waiting",
        uploadSaving: "Saving to Google Drive...",
        uploadDone: "Uploaded",
        uploadFailed: "Upload failed",
        someUploadsFailed: "Some files could not be uploaded",
        photosUploaded: "Media uploaded successfully",
        dearGuest: "Dear",
        footer: "All Rights Reserved © 2026",
        colors: "Colors",
        size: "Size",
        thin: "Thin",
        medium: "Medium",
        thick: "Thick",
        bold: "Bold",
        current: "Current",
        weddingOf: "Wedding of",
        and: "&",
        adminPanel: "Admin Panel",
        login: "Login",
        email: "Email",
        password: "Password",
        logout: "Logout",
        guestsList: "Guests List",
        addGuest: "Add Guest",
        addMultiple: "Add multiple",
        pasteNames: "Paste names (one per line)",
        copyLink: "Copy Link",
        copied: "Copied!",
        remove: "Remove",
        rsvps: "RSVPs",
        messagesTab: "Messages",
        photosTab: "Photos",
        statsTab: "Stats",
        adminLoginTitle: "Admin Panel",
        adminSignIn: "Sign in",
        adminSigningIn: "Signing in...",
        adminWelcome: "Welcome",
        adminInvalidCredentials: "Invalid credentials",
        adminDashboardTitle: "Wedding Admin",
        adminWeddingFallback: "Wedding",
        adminDateNotSet: "Date not set",
        adminAllWeddings: "All weddings",
        adminWeddingsTitle: "Weddings",
        adminWeddingsHint: "Each event has its own guests, invitations, and dashboard.",
        adminCreateWedding: "New wedding",
        adminWeddingSlug: "Slug",
        adminSlugHint: "Lowercase letters, numbers, and hyphens, 2–40 characters.",
        adminDriveFolder: "Google Drive folder id",
        adminCreateWeddingButton: "Create wedding",
        adminWeddingCreated: "Wedding created",
        adminWeddingAdminEmail: "Wedding admin email",
        adminWeddingAdminPassword: "Wedding admin password",
        adminWeddingAdminHint: "Optional. Enter both to create a login for this wedding only.",
        adminWeddingAdminBothRequired: "Enter both the wedding admin email and password",
        adminWeddingAdminCreated: "Wedding created and admin login saved",
        adminNoWeddings: "No weddings yet.",
        adminOpenDashboard: "Open dashboard",
        adminCopyOpenLink: "Copy open link",
        adminStatGuests: "Guests",
        adminStatOpened: "Opened",
        adminStatAttending: "Attending",
        adminStatMessages: "Messages",
        adminStatPhotos: "Photos",
        adminTabGuests: "Guests",
        adminTabRsvps: "RSVPs",
        adminTabMessages: "Messages",
        adminTabPhotos: "Photos",
        adminTabSettings: "Settings",
        adminOpenInvitation: "Open invitation link",
        adminCopy: "Copy",
        adminOpen: "Open",
        adminWhatsapp: "WhatsApp",
        adminQr: "QR code",
        adminQrTitle: "Invitation QR",
        adminQrDownload: "Download QR",
        adminQrAlt: "Invitation QR code",
        adminGuestNamePlaceholder: "Guest name...",
        adminCategoryPlaceholder: "Category...",
        adminAdd: "Add",
        adminBulkAdd: "Bulk add",
        adminBulkCategoryPlaceholder: "Bulk category...",
        adminPasteNamesPlaceholder: "Paste names, one per line...",
        adminAddAll: "Add all",
        adminFilterPlaceholder: "Search by Arabic or English name...",
        adminAllCategories: "All categories",
        adminExportCsv: "Export CSV",
        adminColName: "Name",
        adminColCategory: "Category",
        adminColEnglishName: "English name",
        adminColLinkSent: "Link sent?",
        adminColLink: "Link",
        adminColClicks: "Clicks",
        adminColRsvp: "RSVP",
        adminColActions: "Actions",
        adminEmptyGuests: "No guests yet. Add your first above.",
        adminNoFilterMatch: "No guests match these filters.",
        adminOpenLink: "Open link",
        adminCategoryInputPlaceholder: "Category",
        adminEnglishNamePlaceholder: "English guest name",
        adminSent: "Sent",
        adminNotSent: "Not sent",
        adminClickOne: "click",
        adminClickMany: "clicks",
        adminNever: "Never",
        adminRsvpNo: "No",
        adminPending: "Pending",
        adminTitleCopyLink: "Copy link",
        adminTitleShare: "Share",
        adminTitleDelete: "Delete",
        adminColGuest: "Guest",
        adminColAttending: "Attending",
        adminColCount: "Count",
        adminColNames: "Names",
        adminColTime: "Time",
        adminEmptyRsvps: "No RSVPs yet.",
        adminYes: "Yes",
        adminEmptyMessages: "No messages yet.",
        adminDrawnMessageAlt: "Drawn message",
        adminEmptyPhotos: "No media yet.",
        adminOpenInDrive: "Open in Drive",
        adminVideo: "Video",
        adminUploadedAlt: "Uploaded",
        adminDeletePhoto: "Delete photo",
        adminSettingsHeading: "Wedding details",
        adminSettingsHint: "These values appear on every invitation link.",
        adminTheme: "Theme",
        adminSaving: "Saving...",
        adminSaveSettings: "Save settings",
        adminGroomEn: "Groom name English",
        adminBrideEn: "Bride name English",
        adminGroomAr: "Groom name Arabic",
        adminBrideAr: "Bride name Arabic",
        adminStartDate: "Start date and time",
        adminEndDate: "End date and time",
        adminVenueEn: "Venue English",
        adminVenueAr: "Venue Arabic",
        adminHallEn: "Hall English",
        adminHallAr: "Hall Arabic",
        adminCityEn: "City English",
        adminCityAr: "City Arabic",
        adminAddressEn: "Address English",
        adminAddressAr: "Address Arabic",
        adminMapsUrl: "Google Maps URL",
        adminMapsEmbed: "Embedded map URL",
        adminNoteEn: "Note English",
        adminNoteAr: "Note Arabic",
        adminGuestAdded: "Guest added, custom link copied",
        adminError: "Error",
        adminGuestsAdded: "Added {count} guests",
        adminConfirmOpenRegistration: "This removes this open-link registration.",
        adminConfirmDeleteGuest: "Delete this guest and all their data?",
        adminConfirmDeletePhoto: "Delete this photo?",
        adminLinkCopied: "Link copied",
        adminCopyPrompt: "Copy this link:",
        adminInvitationCopied: "Invitation link copied",
        adminShareTitle: "Wedding invitation",
        adminNoExport: "No filtered guests to export",
        adminSettingsSaved: "Wedding settings saved",
        adminSettingsSaveFailed: "Could not save wedding settings",
        adminCsvName: "Name",
        adminCsvEnglishName: "English name",
        adminCsvCategory: "Category",
        adminCsvInviteLink: "Invite link",
        langSwitch: "عربي",
    },
};

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            return localStorage.getItem("wd-lang") || "ar";
        } catch {
            return "ar";
        }
    });

    useEffect(() => {
        const html = document.documentElement;
        html.setAttribute("lang", lang);
        html.setAttribute("dir", STRINGS[lang].dir);
        try { localStorage.setItem("wd-lang", lang); } catch {}
    }, [lang]);

    const value = useMemo(
        () => ({
            lang,
            setLang,
            toggle: () => setLang((l) => (l === "ar" ? "en" : "ar")),
            t: (key) => STRINGS[lang][key] ?? key,
            dir: STRINGS[lang].dir,
        }),
        [lang]
    );
    return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
}

export function formatDate(dateIso, lang) {
    const d = new Date(dateIso);
    const fmt = new Intl.DateTimeFormat("en-US", {
        timeZone: "Africa/Cairo",
        year: "numeric",
        month: "long",
        day: "numeric",
    });
    const parts = fmt.formatToParts(d);
    const day = parts.find((p) => p.type === "day")?.value || "";
    const monthEn = parts.find((p) => p.type === "month")?.value || "";
    const year = parts.find((p) => p.type === "year")?.value || "";
    if (lang === "ar") {
        const mapping = {
            January: "يناير", February: "فبراير", March: "مارس", April: "أبريل",
            May: "مايو", June: "يونيو", July: "يوليو", August: "أغسطس",
            September: "سبتمبر", October: "أكتوبر", November: "نوفمبر", December: "ديسمبر",
        };
        return `${day} ${mapping[monthEn] || monthEn} ${year}`;
    }
    return `${monthEn} ${day}, ${year}`;
}

export function formatWeekday(dateIso, lang) {
    const d = new Date(dateIso);
    if (Number.isNaN(d.getTime())) return "";
    const locale = lang === "ar" ? "ar-EG" : "en-US";
    return new Intl.DateTimeFormat(locale, {
        timeZone: "Africa/Cairo",
        weekday: "long",
    }).format(d);
}

export function formatTime(dateIso, lang) {
    const d = new Date(dateIso);
    const fmt = new Intl.DateTimeFormat("en-US", {
        timeZone: "Africa/Cairo",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });
    const parts = fmt.formatToParts(d);
    const hour = parts.find((p) => p.type === "hour")?.value || "";
    const minute = parts.find((p) => p.type === "minute")?.value || "";
    const dayPeriod = (parts.find((p) => p.type === "dayPeriod")?.value || "").toUpperCase();
    if (lang === "ar") {
        const ampm = dayPeriod === "AM" ? "صباحاً" : "مساءً";
        return `${hour}:${minute} ${ampm}`;
    }
    return `${hour}:${minute} ${dayPeriod}`;
}
